export const logoutEventType = 'cms-header-loaded'

export const createAndEmitLoadedEvent = () => {
  const event = new CustomEvent(
    logoutEventType,
    {
      bubbles: true
    }
  )
  document.dispatchEvent(event)
}
